import rp, { BrowserEvent } from "@reporting/rp-app-host";
import { AppComponent, Browser, BrowserAdapter } from "@reporting/rp-app-host";
import { html, css } from "lit";
import { customElement, query } from "lit/decorators.js";
import { ChatBrowserAdapter } from "../adapters/chatBrowserAdapter";
import { AIApplication } from "..";

@customElement('rp-mf-ai-chats')
export class ChatList extends AppComponent<AIApplication> {

	static styles = [AppComponent.styles, css`
		:host {
			display: flex;
			flex-direction: column;
			width: 100%;
			height: 100%;
			position: relative;
		}

		rp-browser {
			height: 100%;
		}

		.head {
			flex: 0 0 30px;
			display: flex;
			flex-direction: row;
			justify-content: flex-end;
			border-bottom: 1px solid var(--og-border-color);
		}

		.head og-button {
			width: 30px;
		}

		.head > * {
			height: 30px;
		}

		.body {
			flex: 1;
			overflow: hidden;
		}
	`];
	
	@query('rp-browser')
	browser: Browser;

	
	private _adapter: ChatBrowserAdapter;
	get adapter(): BrowserAdapter { return this._adapter ?? (this._adapter = new ChatBrowserAdapter()) }

	layout() {
		this.browser?.layout();
	}

	newChat() {
		rp.applications.get<AIApplication>('ai').newChat();
	}

	_onBrowserSelect = (e: BrowserEvent) => {
		rp.host.open(`ai-chat-${e.node.key}`, {title: `Chat #${e.node.key}`, preventDisconnect: true});
	};

	render = () => html`
		<div class="head">
			<og-button icon="plus" color="transparent" @click="${() => this.newChat()}"></og-button>
		</div>

		<div class="body">
			<rp-browser .adapter="${this.adapter}" @browser.select="${this._onBrowserSelect}"></rp-browser>
		</div>
	`;

}
